import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "ec-1d8a1d02-d185-4976-9705-378f7b50a6c4-__Layer_1",
  "enable-background": "new 0 0 72 72",
  height: "512",
  viewBox: "0 0 72 72",
  width: "512",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g id=\"ec-cf43d54a-32bb-48f9-a033-599c3e0bdfd5-__Layer_2_1_\"><g id=\"ec-d59acd92-7427-436c-b955-1140660ad2f5-__Layer_1-2\"><g id=\"ec-a62a7115-8108-48ca-9bba-a6e7ba711647-__format_align_left\"><path d=\"m63 15h-54c-1.7 0-3-1.3-3-3s1.3-3 3-3h54c1.7 0 3 1.3 3 3s-1.3 3-3 3z\"></path><path d=\"m45 31h-36c-1.7 0-3-1.3-3-3s1.3-3 3-3h36c1.7 0 3 1.3 3 3s-1.3 3-3 3z\"></path><path d=\"m63 47h-54c-1.7 0-3-1.3-3-3s1.3-3 3-3h54c1.7 0 3 1.3 3 3s-1.3 3-3 3z\"></path><path d=\"m45 63h-36c-1.7 0-3-1.3-3-3s1.3-3 3-3h36c1.7 0 3 1.3 3 3s-1.3 3-3 3z\"></path></g></g></g>", 1)
  ]))]))
}
export default { render: render }